<div tabindex="0" class="me-dynamic-overview-card" *ngIf="data">
    <div class="me-dynamic-overview-card--title">
        {{data.headline}}
    </div>

    <div class="me-dynamic-overview-card--description" [innerHTML]="data.text | storyblokRichtext" *ngIf="items.length > 0"></div>

    <div class="me-dynamic-overview-card--description" [innerHTML]="data.emptyResultsText | storyblokRichtext" *ngIf="items.length === 0"></div>

    <div class="me-dynamic-overview-card--body">
        <div class="me-dynamic-overview-card--body--cluster" *ngFor="let cluster of clusters">
            <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg" [attr.color]="cluster.color">
                <path opacity="0.78" d="M17.3859 10.6153C18.3027 9.3151 18.1071 7.80997 17.7191 6.49346C17.3301 5.16352 16.3974 4.0924 15.2083 3.18829C13.8584 2.15854 12.4793 1.04637 10.5063 0.986513C8.46587 0.920093 6.26301 1.67728 4.59953 2.86812C3.00794 4.00639 2.50306 5.67964 1.75543 7.23909C1.00995 8.78853 -0.184224 10.3566 0.29545 11.8301C0.76977 13.2859 2.65606 13.9132 4.20834 14.6779C5.6686 15.3972 7.12559 16.4334 8.95689 16.0972C10.744 15.77 11.6122 14.0075 13.1054 13.0364C14.5005 12.1291 16.509 11.8591 17.3859 10.6153Z" 
                    fill="currentColor">
                </path>
            </svg>
            <b>{{cluster.percent}}%</b>
            <span>{{cluster.name}}</span>
        </div>
    </div>

    <div class="me-dynamic-overview-card--btn" *ngIf="items.length > 0">
        <button class="btn btn--primary" [routerLink]="['/me/dynamic-report']">
            {{data.resultsButtonText}}
        </button>
        <button class="btn btn--secondary" [routerLink]="['/me/dynamic-report/onboarding']">
            {{data.tutorialButtonText}}
        </button>
    </div>
</div>